import React from "react";

const TotalSalesEndShift = ({ row }) => {
  return <div>{row?.totalSales?.toLocaleString()}</div>;
};

export default TotalSalesEndShift;
